import { MutableRefObject } from 'react';
import { FC } from 'react';
import React from 'react';
import { useUncontrolled } from './Input/plugins/useUncontrolled';
import { TextInput } from './TextInput';
import { Props as TextInputProps } from './TextInput';

type ExtraProps = {
    value: any;
    onChange: (value: any) => void;
    inputRef?: MutableRefObject<HTMLInputElement | null>;
    onInputRef?: (inputRef: HTMLInputElement | null) => void;
};

export type Props = ExtraProps & Omit<TextInputProps, keyof ExtraProps>;

export const UncontrolledTextInput: FC<Props> = ({
    inputRef: externalInputRef,
    value: externalValue,
    onChange: externalOnChange,
    ...props
}) => {
    const uncontrolledProps = useUncontrolled<any>({
        inputRef: externalInputRef,
        value: externalValue,
        onChange: externalOnChange,
    });
    return <TextInput {...props} {...uncontrolledProps} />;
};
